// extracted by mini-css-extract-plugin
export default {"trialImageContainer":"TrialImage-module__trialImageContainer___YeT3U","svgWrapper":"TrialImage-module__svgWrapper___Vy_TV"};